// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2odiQ","description":"PatientConsentPreview_description__21ZB1"};